import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'
import moment from 'moment'

export const CachedDropdownsState = {
  dropdowns: {},
  isWaiting: null,
  queue: {},
  dropdownsTTL: {},
}

// http://localhost:3000/options/spouses/immigration_status

export const CachedDropdownsActions = {
  getDropdownOptions: async ({ commit, dispatch, getters }, { path, options = true, force = false, queryParams = {}, identifier = null, ttl = null }) => {
    if (force && getters.hasCachedDropdown(identifier || path)) commit('removeCachedDropdown', identifier || path)

    if (!force) {
      if (ttl) {
        const lastUpdated = getters.getCachedDropdownLastUpdated(identifier || path)
        if (lastUpdated && moment().isBefore(moment(lastUpdated).add(ttl, 'seconds'))) return getters.getCachedDropdown(identifier || path)
        else commit('removeCachedDropdown', identifier || path)
      }

      if (getters.hasCachedDropdown(identifier || path)) return getters.getCachedDropdown(identifier || path)
    }

    if (!getters.isWaiting) {
      setTimeout(_ => { dispatch('loadDropdowns') }, 500)
      commit('setIsWaiting', true)
    }

    commit('addToQueue', {
      key: identifier || path,
      call: options ? `/options/${path}` : `/${path}`,
      params: queryParams,
      success: ({ data }) => {
        if (Array.isArray(data)) {
          commit('setCachedDropdown', { key: identifier || path, options: data })
        } else {
          commit('setCachedDropdown', { key: identifier || path, options: data?.options || [] })
        }
      },
      error: handleError,
    })
  },

  getSurveyDropdownOptions: async ({ commit, dispatch, getters }, { session, options: { path, options = true, force = false } }) => {
    if (!force && getters.hasCachedDropdown(path)) return getters.getCachedDropdown(path)

    if (!getters.isWaiting) {
      setTimeout(_ => { dispatch('loadDropdowns') }, 500)
      commit('setIsWaiting', true)
    }

    commit('addToQueue', {
      key: path,
      call: options ? `/survey/${session}/options/${path}` : `/survey/${session}/root_options/${path}`,
      success: ({ data }) => {
        if (Array.isArray(data)) commit('setCachedDropdown', { key: path, options: data })
        else commit('setCachedDropdown', { key: path, options: data?.options || [] })
      },
      error: handleError,
    })
  },

  loadDropdowns: async ({ commit, getters }) => {
    // for (const item of getters.getQueue) {
    //   axiosRequest.get(item.call).then(item.success).catch(item.error)
    //   commit('removeFromQueue', item.key)
    // }
    for (const identifier of getters.getQueueIdentifiers) {
      const item = getters.getQueue(identifier)
      axiosRequest.get(item.call, { params: item.params }).then(item.success).catch(item.error)
      commit('removeFromQueue', identifier)
    }

    commit('setIsWaiting', false)
  },
}

export const CachedDropdownsMutations = {
  addToQueue: (state, { key, call, success, error, params, ttl }) => { Vue.set(state.queue, key, { call, success, error, params, ttl }) },
  removeFromQueue: (state, key) => { Vue.delete(state.queue, key) },
  setCachedDropdown: (state, { key, options }) => {
    Vue.set(state.dropdowns, key, {
      options,
      lastUpdated: Date.now(),
    })
  },
  removeCachedDropdown: (state, key) => { Vue.delete(state.dropdowns, key) },
  setIsWaiting: (state, value) => { state.isWaiting = value },
}

export const CachedDropdownsGetters = {
  getCachedDropdown: state => model => state.dropdowns[model]?.options || [],
  isCachedDropdownLoading: state => model => !!state.queue[model],
  getQueue: state => key => state.queue[key],
  getQueueIdentifiers: state => Object.keys(state.queue),
  hasCachedDropdown: state => model => !!state.dropdowns[model],
  getCachedDropdownLastUpdated: state => model => state.dropdowns[model]?.lastUpdated || null,
  isWaiting: state => state.isWaiting,
}
